var Backbone, EmailFormTextInputView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

EmailFormTextInputView = (function(superClass) {
  extend(EmailFormTextInputView, superClass);

  function EmailFormTextInputView() {
    return EmailFormTextInputView.__super__.constructor.apply(this, arguments);
  }

  EmailFormTextInputView.prototype.initialize = function(options) {
    var ref, ref1;
    this.options = options || {};
    this.I18nScope = 'modules.support';
    this.isInputFieldEmpty = true;
    this.maxLength = 250;
    this.model = this.options.model;
    this.isFlexibleStepThree = this.options.isFlexibleStepThree;
    this.label = this.model.label;
    this.value = this.model.value;
    this.base_template = this.options.template;
    this.isInputCompulsory = this.model.required === true || this.model.required === "true";
    if (((ref = this.options.model.additional_attributes) != null ? (ref1 = ref.maximum_number_of_characters_or_digits) != null ? ref1.length : void 0 : void 0) > 0) {
      return this.maxLength = parseInt(this.options.model.additional_attributes.maximum_number_of_characters_or_digits);
    }
  };

  EmailFormTextInputView.prototype.render = function() {
    return this.$el.html(toHtml(this.base_template, this.toHash()));
  };

  EmailFormTextInputView.prototype.toHash = function() {
    var hash;
    hash = {
      stepThreeType: this.isFlexibleStepThree ? 'flexibleStepThree' : 'defaultStepThree',
      label: this.label,
      required: this.isInputCompulsory,
      maxLength: this.maxLength,
      counter: this.model.counter,
      isLoggedIn: window.isLoggedIn,
      value: this.value
    };
    return _.extend(this.template, hash);
  };

  EmailFormTextInputView.prototype.getInputHtmlElement = function() {
    return this.$el.find(this.elementID);
  };

  EmailFormTextInputView.prototype.isInputGiven = function() {
    var ref, ref1, ref2;
    return ((ref = this.getInputHtmlElement()) != null ? (ref1 = ref.val()) != null ? (ref2 = ref1.trim()) != null ? ref2.length : void 0 : void 0 : void 0) > 0;
  };

  EmailFormTextInputView.prototype.readInput = function() {
    var ref, ref1;
    return (ref = this.getInputHtmlElement()) != null ? (ref1 = ref.val()) != null ? ref1.trim() : void 0 : void 0;
  };

  EmailFormTextInputView.prototype.isInputValid = function() {
    return true;
  };

  EmailFormTextInputView.prototype.validateEmailForm = function() {
    if (this.isInputCompulsory && ((this.isInputFieldEmpty && this.isInputGiven()) || !(this.isInputFieldEmpty || this.isInputGiven()))) {
      this.isInputFieldEmpty = !this.isInputGiven();
      return this.options.validateEmailForm();
    }
  };

  EmailFormTextInputView.prototype.populateInput = function(data) {
    var inputData;
    if (this.isInputGiven()) {
      inputData = this.readInput();
      return data.description += "\n\n " + this.label + " : " + inputData;
    }
  };

  return EmailFormTextInputView;

})(Backbone.View);

module.exports = EmailFormTextInputView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvY29tbW9uL3ZpZXdzL3RleHRfaW5wdXRfdmlldy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9ybXVydWdhbi9uYXBpc3RyYW5vL2J1aWxkLzE1MDE3ODIwMTYzMDYtNTk0MzUvcHJvZHVjdGlvbi0yMDE3LjA4LjAzXzE3LjM2L3N1cHBvcnRfYXBwL21vZHVsZXMvc3VwcG9ydC9mcm9udGVuZC92aWV3cy9jb21tb24vdmlld3MvdGV4dF9pbnB1dF92aWV3LmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBLGdDQUFBO0VBQUE7OztBQUFBLFFBQUEsR0FBVyxPQUFBLENBQVEsVUFBUjs7QUFDWCxRQUFRLENBQUMsQ0FBVCxHQUFhOztBQUVQOzs7Ozs7O21DQUVKLFVBQUEsR0FBWSxTQUFDLE9BQUQ7QUFDVixRQUFBO0lBQUEsSUFBQyxDQUFBLE9BQUQsR0FBVyxPQUFBLElBQVc7SUFDdEIsSUFBQyxDQUFBLFNBQUQsR0FBYTtJQUNiLElBQUMsQ0FBQSxpQkFBRCxHQUFxQjtJQUNyQixJQUFDLENBQUEsU0FBRCxHQUFhO0lBQ2IsSUFBQyxDQUFBLEtBQUQsR0FBUyxJQUFDLENBQUEsT0FBTyxDQUFDO0lBQ2xCLElBQUMsQ0FBQSxtQkFBRCxHQUF1QixJQUFDLENBQUEsT0FBTyxDQUFDO0lBQ2hDLElBQUMsQ0FBQSxLQUFELEdBQVMsSUFBQyxDQUFBLEtBQUssQ0FBQztJQUNoQixJQUFDLENBQUEsS0FBRCxHQUFTLElBQUMsQ0FBQSxLQUFLLENBQUM7SUFDaEIsSUFBQyxDQUFBLGFBQUQsR0FBaUIsSUFBQyxDQUFBLE9BQU8sQ0FBQztJQUMxQixJQUFDLENBQUEsaUJBQUQsR0FBcUIsSUFBQyxDQUFBLEtBQUssQ0FBQyxRQUFQLEtBQW1CLElBQW5CLElBQTJCLElBQUMsQ0FBQSxLQUFLLENBQUMsUUFBUCxLQUFtQjtJQUNuRSxrSUFBK0UsQ0FBRSx5QkFBOUUsR0FBdUYsQ0FBMUY7YUFDRSxJQUFDLENBQUEsU0FBRCxHQUFhLFFBQUEsQ0FBUyxJQUFDLENBQUEsT0FBTyxDQUFDLEtBQUssQ0FBQyxxQkFBcUIsQ0FBQyxzQ0FBOUMsRUFEZjs7RUFYVTs7bUNBY1osTUFBQSxHQUFRLFNBQUE7V0FDTixJQUFDLENBQUEsR0FBRyxDQUFDLElBQUwsQ0FBVSxNQUFBLENBQU8sSUFBQyxDQUFBLGFBQVIsRUFBdUIsSUFBQyxDQUFBLE1BQUQsQ0FBQSxDQUF2QixDQUFWO0VBRE07O21DQUdSLE1BQUEsR0FBUSxTQUFBO0FBQ04sUUFBQTtJQUFBLElBQUEsR0FDRTtNQUFBLGFBQUEsRUFBa0IsSUFBQyxDQUFBLG1CQUFKLEdBQTZCLG1CQUE3QixHQUFzRCxrQkFBckU7TUFDQSxLQUFBLEVBQU8sSUFBQyxDQUFBLEtBRFI7TUFFQSxRQUFBLEVBQVUsSUFBQyxDQUFBLGlCQUZYO01BR0EsU0FBQSxFQUFXLElBQUMsQ0FBQSxTQUhaO01BSUEsT0FBQSxFQUFTLElBQUMsQ0FBQSxLQUFLLENBQUMsT0FKaEI7TUFLQSxVQUFBLEVBQVksTUFBTSxDQUFDLFVBTG5CO01BTUEsS0FBQSxFQUFPLElBQUMsQ0FBQSxLQU5SOztXQU9GLENBQUMsQ0FBQyxNQUFGLENBQVMsSUFBQyxDQUFBLFFBQVYsRUFBb0IsSUFBcEI7RUFUTTs7bUNBV1IsbUJBQUEsR0FBcUIsU0FBQTtXQUNuQixJQUFDLENBQUEsR0FBRyxDQUFDLElBQUwsQ0FBVSxJQUFDLENBQUEsU0FBWDtFQURtQjs7bUNBR3JCLFlBQUEsR0FBYyxTQUFBO0FBQ1osUUFBQTt5SEFBcUMsQ0FBRSxrQ0FBdkMsR0FBZ0Q7RUFEcEM7O21DQUdkLFNBQUEsR0FBVyxTQUFBO0FBQ1QsUUFBQTt5RkFBNkIsQ0FBRSxJQUEvQixDQUFBO0VBRFM7O21DQUdYLFlBQUEsR0FBYyxTQUFBO1dBQ1o7RUFEWTs7bUNBR2QsaUJBQUEsR0FBbUIsU0FBQTtJQUNqQixJQUFHLElBQUMsQ0FBQSxpQkFBRCxJQUFzQixDQUFDLENBQUMsSUFBQyxDQUFBLGlCQUFELElBQXNCLElBQUMsQ0FBQSxZQUFELENBQUEsQ0FBdkIsQ0FBQSxJQUEyQyxDQUFDLENBQUMsSUFBQyxDQUFBLGlCQUFELElBQXNCLElBQUMsQ0FBQSxZQUFELENBQUEsQ0FBdkIsQ0FBN0MsQ0FBekI7TUFDRSxJQUFDLENBQUEsaUJBQUQsR0FBcUIsQ0FBQyxJQUFDLENBQUEsWUFBRCxDQUFBO2FBQ3RCLElBQUMsQ0FBQSxPQUFPLENBQUMsaUJBQVQsQ0FBQSxFQUZGOztFQURpQjs7bUNBS25CLGFBQUEsR0FBZSxTQUFDLElBQUQ7QUFDYixRQUFBO0lBQUEsSUFBRyxJQUFDLENBQUEsWUFBRCxDQUFBLENBQUg7TUFDRSxTQUFBLEdBQVksSUFBQyxDQUFBLFNBQUQsQ0FBQTthQUNaLElBQUksQ0FBQyxXQUFMLElBQW9CLE9BQUEsR0FBUSxJQUFDLENBQUEsS0FBVCxHQUFlLEtBQWYsR0FBb0IsVUFGMUM7O0VBRGE7Ozs7R0EvQ29CLFFBQVEsQ0FBQzs7QUFvRDlDLE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
